//All kind of contants mapping will be done here

module.exports = {
    REPORT: 1,
    TRF: 2,
    MONEY_REQUEST: 3,
    TRANSACTION: 4,
    TR: 5,
    MONEY_REQUEST_ITEM: 6,
    USER_ITEM: 7,
    ACTOR_ITEM: 8,
    CARD_LOAD: 9,
    FLIGHT_SEARCH: 11,
    FLIGHT_SEGMENT: 12,
    FLIGHT_SEARCH_AGGREGATE: 13,
    BOOKING: 14,
    SPLIT: 4,
    HOTEL_SEARCH: 15,
    TRIP: 16,
    FLIGHT_DOMESTIC_ONLINE: 17,
    FLIGHT_DOMESTIC_OFFLINE: 18,
    FLIGHT_INTERNATIONAL_ONLINE: 19,
    FLIGHT_INTERNATIONAL_OFFLINE: 20,
    HODEL_DOMESTIC_ONLINE: 21,
    HOTEL_DOMESTIC_OFFLINE: 22,
    HOTEL_INTERNATIONAL_ONLINE: 23,
    HOTEL_INTERNATIONAL_OFFLINE: 24,
    CAR_DOMESTIC_ONLINE: 25,
    CAR_DOMESTIC_OFFLINE: 26,
    CAR_INTERNATIONAL_ONLINE: 27,
    CAR_INTERNATIONAL_OFFLINE: 28,
    TRAIN_DOMESTIC_ONLINE: 29,
    TRAIN_DOMESTIC_OFFLINE: 30,
    TRAIN_INTERNATIONAL_ONLINE: 31,
    TRAIN_INTERNATIONAL_OFFLINE: 32,
    BUS_DOMESTIC_OFFLINE: 33,
    BUS_INTERNATIONAL_OFFLINE: 34,
    ADVANCE_DOMESTIC_OFFLINE: 35,
    ADVANCE_INTERNATIONAL_OFFLINE: 36,
    "Self Product 1 Offline": 37,
    "Self Product 2 Offline": 38,
    "Self Product 3 Offline": 39,
    "Self Product 4 Offline": 40,
    "Self Product 5 Offline": 41,
    "Self Product 6 Offline": 42,
    1: "REPORT",
    2: "TRF",
    3: "MONEY_REQUEST",
    4: "TRANSACTION",
    5: "TR",
    6: "MONEY_REQUEST_ITEM",
    7: "USER_ITEM",
    8: "ACTOR_ITEM",
    9: "CARD_LOAD",
    11: "FLIGHT_SEARCH",
    12: "FLIGHT_SEGMENT",
    13: "FLIGHT_SEARCH_AGGREGATE",
    14: "Booking",
    15: "HOTEL_SEARCH",
    16: "TRIP",
    17: "FLIGHT_DOMESTIC_ONLINE",
    18: "FLIGHT_DOMESTIC_OFFLINE",
    19: "FLIGHT_INTERNATIONAL_ONLINE",
    20: "FLIGHT_INTERNATIONAL_OFFLINE",
    21: "HODEL_DOMESTIC_ONLINE",
    22: "HOTEL_DOMESTIC_OFFLINE",
    23: "HOTEL_INTERNATIONAL_ONLINE",
    24: "HOTEL_INTERNATIONAL_OFFLINE",
    25: "CAR_DOMESTIC_ONLINE",
    26: "CAR_DOMESTIC_OFFLINE",
    27: "CAR_INTERNATIONAL_ONLINE",
    28: "CAR_INTERNATIONAL_OFFLINE",
    29: "TRAIN_DOMESTIC_ONLINE",
    30: "TRAIN_DOMESTIC_OFFLINE",
    31: "TRAIN_INTERNATIONAL_ONLINE",
    32: "TRAIN_INTERNATIONAL_OFFLINE",
    33: "BUS_DOMESTIC_OFFLINE",
    34: "BUS_INTERNATIONAL_OFFLINE",
    35: "ADVANCE_DOMESTIC_OFFLINE",
    36: "ADVANCE_INTERNATIONAL_OFFLINE",
    37: "Self Product 1 Offline",
    38: "Self Product 2 Offline",
    39: "Self Product 3 Offline",
    40: "Self Product 4 Offline",
    41: "Self Product 5 Offline",
    42: "Self Product 6 Offline",

    SIZE_PER_PAGE_LIST: [10, 20, 30, 40, 50, 100],
    SIZE_PER_PAGE: 30,

    //keys for workflow comments
    ITEM: 3,
    CONTAINER: 4,
    ADHOC: 10,
    STATE: 6,
    ALL_COMMENTS: 7,
    Sum__amount: "amount__sum",
    Count__txn_id: "txn_id__count",
    Avg__amount: "amount__avg",
    DISPLAY_FORMAT: "L",
    ISO_FORMAT: "YYYY-MM-DD",
    ISO_MONTH_FORMAT: "YYYY-MM",

    START_DATE: "startDate",
    END_DATE: "endDate",

    HORIZONTAL_ORIENTATION: "horizontal",
    VERTICAL_ORIENTATION: "vertical",
    VERTICAL_SCROLLABLE: "verticalScrollable",

    ANCHOR_LEFT: "left",
    ANCHOR_RIGHT: "right",

    DAY_SIZE: 39,
    BLOCKED_MODIFIER: "blocked",
    airlines: [
        "RQ",
        "XY",
        "TR",
        "G9",
        "AK",
        "FR",
        "3O",
        "D7",
        "QZ",
        "LS",
        "J9",
        "4U",
        "TT",
        "B6",
        "EI",
        "FD",
        "WW",
        "5J",
        "XR",
        "VC",
        "JE",
        "E3",
        "7H",
        "WS",
        "8J",
        "PK",
        "JQ",
        "3K",
        "ZL",
        "VY",
        "AB",
        "PC",
        "DE",
        "X5",
        "5W",
        "L9",
        "LZ",
        " BE",
        "F7",
        "RE",
        "I9",
        "ML",
        "AP",
        "SZ",
        "L9",
        "KF",
        "BV",
        "WX",
        "T3",
        "FC",
        "FZ",
        "TCX",
        "F9",
        "NM",
        "8N",
        "O6",
        "JZ",
        "BY",
        "HV",
        "IV",
        "WJ",
        "AF",
        "MT",
        "X3",
        "JW",
        "IG",
        "SI",
        "FL",
        "VB",
        "3L",
        "2L",
        "FY",
        "BN",
        " U2",
        "SA",
        "XC",
        "W6",
        "3J",
        "RI",
        "VF",
        "BL",
        "2P",
        "DG",
        "OD",
        "BA",
        "SQ",
        "DL",
        "EK",
        "PK",
        "TK",
        "UA",
        "KL",
        "AA",
        "US",
        "LH",
        "AC",
        "BD",
        "EY",
        "QR",
        "AZ",
        "KU",
        "CI",
        "GF",
        "MU",
        "MS",
        "MH",
        "QF",
        "LX",
        "AY",
        "TO",
        " RJ",
        "DY",
        "U6",
        "IB",
        "UL",
        "SV",
        "S7",
        "PA",
        "XT",
        "I5"
    ],
    eliminateOrgs: [
        "HPORG201722717225610201388HP",
        "HPORG201711181759205304321009HP",
        "HPORG2018124656542908233761HP",
        "HPORG2018318716594903046301HP",
        "HPORG201852848312902392900HP",
        "HPORG2018530611401401173895HP",
        "HPORG2018611627406758878230HP",
        "HPORG20186201532416912104195HP",
        "HPORG201852361253147994964HP",
        "HPORG2018517750104396196757HP",
        "HPORG2018720732516458339271HP",
        "HPORG201882392728919138263HP"
    ],
    happayProductMap: {
        "card-management": 1,
        "expense-management": 2,
        "vendor-management": 3
    },
    efValueType: {
        dropdown: 3,
        text: 2,
        number: 1,
        multi_select_dropdown: 3,
        date: 4
    },

    PASSPORT_REGEX: /^[a-zA-Z]{1}\d{7}$/,
    DRIVING_LICENSE_REGEX: /^[a-zA-Z0-9]{15,}$/,
    PAN_CARD_REGEX: /^[a-zA-Z0-9]{5}\d{4}[a-zA-z0-9]$/,
    VOTER_ID: /^[a-zA-Z]{3}\d{7}$/,

    MIN_KYC_DOCUMENT: [
        { value: "pan_card", text: "PAN Card" },
        { value: "driving_license", text: "Driving Licence" },
        { value: "passport", text: "Passport" },
        { value: "voter_id", text: "Voter ID" }
    ]
    /*flexi_benefits:{
  		0:{
  			hidden:false,text:"TRANSACTION"
  		},
  		1:{
  			hidden:false,text:"ADD FLEXI EXPENSE"
  		},
  		2:{
  			hidden:false,text:"ADD FLEXI New Expense"
  		},
  		3:{
  			hidden:false,text:"ADD FLEXI Existing Expense"
  		},
  		10:{
  			hidden:false,text:"Flexi Comments"
  		},
  		12:{
  			hidden:false,text:"Flexi Create Expense"
  		},
  		26:{
  			hidden:false,text:"Flexi Edit Expense"
  		},
  	}*/
};
